export default "__VITE_ASSET__jYxj_kFX__"